import { number, object } from "yup";

export const getValidation = (monitoringById: number | null) => ({
  validationSchema: object({
    doctor: number().nullable()
  }),
  defaultValues: {
    doctor: monitoringById
  }
});
